import { type AnalyticsAction, ActionType } from './types'

export class View implements AnalyticsAction {
  name = 'View'
  type = ActionType.View
}

export class Open implements AnalyticsAction {
  name = 'Open'
  type = ActionType.View
}

export class Close implements AnalyticsAction {
  name = 'Close'
  type = ActionType.Track
}

export class Hover implements AnalyticsAction {
  name = 'Hover'
  type = ActionType.Track
}

export class Clickout implements AnalyticsAction {
  name = 'Clickout'
  type = ActionType.Track
}

export class Submit implements AnalyticsAction {
  name = 'Submit'
  type = ActionType.Track
}

export class Click implements AnalyticsAction {
  name = 'Click'
  type = ActionType.Track
}

export class SignUp implements AnalyticsAction {
  name = 'Sign-up'
  type = ActionType.Track
}

export class Save implements AnalyticsAction {
  name = 'Save'
  type = ActionType.Track
}

export class Error implements AnalyticsAction {
  name = 'Error'
  type = ActionType.View
}

export class Redirect implements AnalyticsAction {
  name = 'Redirect'
  type = ActionType.Internal
}
